import { render, staticRenderFns } from "./ButtonDropdownItem.vue?vue&type=template&id=23e630b2&scoped=true"
import script from "./ButtonDropdownItem.vue?vue&type=script&lang=js"
export * from "./ButtonDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./ButtonDropdownItem.vue?vue&type=style&index=0&id=23e630b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e630b2",
  null
  
)

export default component.exports